"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/ban-ts-comment */
const OnEventHandler_1 = require("../Framework/Decorators/OnEventHandler");
const Strings_1 = require("../Utility/Strings");
class Framework {
    constructor() {
        this.views = new Map();
        this.propertyDecorators = new Map();
        this.wiredDecorators = new Map();
        this.functionDecorators = new Map();
        this.onEventHandler = new OnEventHandler_1.default();
    }
    getOnEventHandler() {
        return this.onEventHandler;
    }
    /**
     * Register a element-view relation
     */
    registerView(element, view) {
        this.views.set(element, view);
    }
    /**
     * Unregister a deleted view-element relation
     */
    unregisterView(element) {
        this.views.delete(element);
    }
    /**
     * Test if a view is registered for the given element
     */
    hasView(element) {
        return this.views.get(element) !== undefined;
    }
    /**
     * Get the view for the given element
     */
    getView(element) {
        const view = this.views.get(element);
        if (view === undefined) {
            throw new Error('Unable to retrieve view for element');
        }
        return view;
    }
    /**
     * The "prop" decorators
     */
    registerPropertyDecorator(target, property, types) {
        let properties = this.propertyDecorators.get(target);
        if (properties === undefined) {
            properties = [];
            this.propertyDecorators.set(target, properties);
        }
        properties.push({ property, types });
    }
    applyPropertyDecorators(target, element) {
        const properties = this.propertyDecorators.get(Object.getPrototypeOf(Object.getPrototypeOf(target)));
        if (properties === undefined) {
            return;
        }
        properties.forEach((propertyType) => {
            if (element.dataset[propertyType.property] !== undefined) {
                // @ts-expect-error force set a class private property
                target[propertyType.property] = Strings_1.default.typeCast(element.dataset[propertyType.property], propertyType.types);
            }
            else if (propertyType.types.includes(null)) {
                // @ts-expect-error force set a class private property
                target[propertyType.property] = null;
            }
        });
    }
    /**
     * The "wired" decorators
     */
    registerWiredDecorator(target, property, role) {
        let list = this.wiredDecorators.get(target);
        if (list === undefined) {
            list = new Array();
            this.wiredDecorators.set(target, list);
        }
        list.push({ property: property, role: role });
    }
    applyWiredDecorator(target, element) {
        const wires = this.wiredDecorators.get(Object.getPrototypeOf(Object.getPrototypeOf(target)));
        if (wires === undefined || wires.length === 0) {
            return;
        }
        wires.forEach((wiredProperty) => {
            // @ts-expect-error force set a class private property
            target[wiredProperty.property] = element.querySelector('[data-role="' + wiredProperty.role + '"]') || undefined;
        });
    }
    /**
     * The "onX" decorators
     */
    registerFunctionDecorator(target, options) {
        let map = this.functionDecorators.get(target);
        if (map === undefined) {
            map = new Map();
            this.functionDecorators.set(target, map);
        }
        let list = map.get(options.propertyKey);
        if (list === undefined) {
            list = new Array();
            map.set(options.propertyKey, list);
        }
        list.push(options);
    }
    /**
     * Apply function decorators to all the class's methods
     */
    applyFunctionDecorators(target, element, remount) {
        // as View class is extended to overwrite the constructor (see Component.ts), get parent of parent of the target.
        const map = this.functionDecorators.get(Object.getPrototypeOf(Object.getPrototypeOf(target)));
        map === null || map === void 0 ? void 0 : map.forEach(values => values.forEach((options) => {
            if (remount === false || options.remount !== false) {
                options.decorator(target, element, options.fn);
            }
        }));
    }
}
exports.default = Framework;
//# sourceMappingURL=Framework.js.map